import * as types from "../actions/actionTypes";

const initialState = {
  calculations: [],
  calculation: null,
};

const calculation = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_CALCULATION_RESPONSE:
      return { ...state, calculations: action.payload };
    case types.GET_CALCULATION_RESPONSE:
      return { ...state, calculation: action.payload };

    case types.CREATE_CALCULATION:
      return { ...state, calculation: null };
    case types.DELETE_CALCULATION:
      return { ...state, calculation: null };
    case types.UPDATE_CALCULATION:
      return { ...state, calculation: null };
    case types.GET_CALCULATION_BY_CARDBUNDLE_ID:
      return { ...state, calculation: null };
    default:
      return state;
  }
};

export default calculation;
